import React from 'react';
import dayjs, { Dayjs } from 'dayjs';
import './CalendarFetchByDay.scss';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { isToday, isYesterDay } from '../../../utils/date';
import analyticsWrapper from '../../../utils/analyticsWrapper';

function getDayToShow(startDate: Dayjs): string {
  if (isToday(startDate)) {
    return 'Today';
  } else if (isYesterDay(startDate)) {
    return 'Yesterday';
  } else {
    return `${dayjs(startDate).format('DD. MMM')}`;
  }
}

export function CalendarFetchByDay({
  fetchValues,
  givenDate = dayjs(new Date()),
  trackingName,
}: {
  fetchValues;
  givenDate: Dayjs;
  trackingName: string;
}): JSX.Element {
  const changeDay = (changeInt: number, theDate: Dayjs) => {
    const fetchGivenDate = dayjs(theDate).add(changeInt > 0 ? 1 : -1, 'day');
    fetchValues(fetchGivenDate);
  };

  return (
    <div className="calendarfetchByDay">
      <div className="calendarRow">
        <div className="choosePeriod">
          <div className="positionChooser">
            <FaChevronLeft
              className="changeDateBtn"
              onClick={() => {
                changeDay(-1, givenDate);
                analyticsWrapper.event({
                  category: trackingName,
                  action: `see-previous-day`,
                  label: 'click',
                });
              }}
            />
            <div className="cal-week"> {`${getDayToShow(givenDate)}`} </div>
            {isToday(givenDate) ? (
              <> </>
            ) : (
              <FaChevronRight
                className="changeDateBtn"
                onClick={() => {
                  changeDay(1, givenDate);
                  analyticsWrapper.event({
                    category: trackingName,
                    action: `see-next-day`,
                    label: 'click',
                  });
                }}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
